<template>

  <div class="tile is-parent" id="login">
    <br>
    <div class="tile is-4 is-child">
      <!-- Add content or other tiles -->

    </div>
    <div class="tile is-4 is-child">
      <!-- Add content or other tiles -->

      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            EFO Administratie
          </p>

        </header>
        <div class="card-content">
          <section>
            <p>
              <center>De volgende velden zijn verplicht in te vullen!</center>
              <br>
            </p>
          </section>

       
  
            <b-field label="E-mail" prop="email">
              <b-input type="email" v-model="firstlogin_form.email"></b-input>
            </b-field>
            <b-field label="Schermnaam" prop="displayname">
              <b-input type="text" minlength="3" v-model="firstlogin_form.displayname"></b-input>
            </b-field>
            <!-- <b-field label="Watchwoord" prop="password">
                    <b-input type="password" minlength="2" v-model="firstlogin_form.password" password-reveal></b-input>
                  </b-field> -->
                  <!--
                  <b-field label="Bevestigen" prop="password_check">
                    <b-input type="password" minlength="5" v-model="firstlogin_form.password_check" auto-complete="off"></b-input>
                  </b-field> -->

            <template v-if="active = 0">
              <button class="button is-primary" disabled>Submit</button>
            </template>
            <template v-else>
              <button class="button is-primary" @click="submitForm('firstlogin_form')">Submit</button>
            </template>
            <button class="button" @click="resetForm('firstlogin_form')">Reset</button>

    

        </div>
      </div>

    </div>
    <div class="tile is-4 is-child">
      <!-- Add content or other tiles -->

    </div>
  </div>

</template>
<script>
import Axios from "axios";
import Cookies from "js-cookie";
import { API_ROOT } from "../config";
var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000
});

export default {
  name: "firstlogin",

  data() {
    return {
      active: 1,
      firstlogin_form: {},
      user: Cookies.getJSON("user"),
      access: Cookies.get("user"),
      users: {}
    };
  },

  computed: {
    // user() {
    //   return this.$store.getters.getUser;
    // },
    firstlogin() {
      return this.$store.getters.getFirstlogin;
    }
  },
  watch: {
    firstlogin: function(val) {
      console.log(val);
      if (val.success) {
        this.$toast.open({
          message: val.msg,
          type: "is-success"
        });
        this.$router.push({
          path: "/"
        });
      } else {
        this.$toast.open({
          message: val.msg,
          type: "is-danger"
        });
      }
    }
  },
  created() {
    console.log(this.user.id);

    this.getUser();
  },
  methods: {
    getUser() {

      var self = this;
      instance.get("/user/" + this.user.id).then(function(response) {
        self.firstlogin_form =response.data.data;

      console.log(self.firstlogin_form);
        self.loading = false;
       
      });
    },
    submitForm(formName) {
      // this.$refs[formName].validate(valid => {
      //   if (valid) {
      //     console.log(this.user);
   


      console.log(this.firstlogin_form);
      this.$store.dispatch("firstlogin", this.firstlogin_form);
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
